{
    "releaseNotes": {
        "tabName": "Release History",
        "accordianHeading": "Release me@eon V<version>",
        "accordianMyHelpHeading": "Release MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Release MyHelp V<version>",
        "whatsNew": "Was ist neu",
        "tipsAndTricks": "Tipps und Tricks",
        "faq": "FAQ"
    },
    "ourTeam": {
        "tabName": "Unser Team",
        "keyMembers": "Schlüsselmitglieder"
    },
    "featureRoadmap": {
        "tabName": "Funktionen & Fahrplan"
    }
}